import { render, staticRenderFns } from "./OrgObjectCard.vue?vue&type=template&id=41d224ee&scoped=true"
import script from "./OrgObjectCard.vue?vue&type=script&lang=js"
export * from "./OrgObjectCard.vue?vue&type=script&lang=js"
import style0 from "./OrgObjectCard.vue?vue&type=style&index=0&id=41d224ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d224ee",
  null
  
)

export default component.exports